export const CONFIRMED_GET_ANUPANS = "CONFIRMED_GET_ANUPANS";
export const CONFIRMED_CREATE_ANUPAN = "CONFIRMED_CREATE_ANUPAN";
export const CONFIRMED_EDIT_ANUPAN = "CONFIRMED_EDIT_ANUPAN";
export const CONFIRMED_DELETE_ANUPAN = "CONFIRMED_DELETE_ANUPAN";
